// Build-stamp: 2026-04-22T09:05Z — re-touched AGAIN to force Lovable auto-deploy.
// cdfea09 (index.html noscript list with 12 new URLs) landed 30+ min ago; deploy
// X-Deployment-Id stuck at aad41241 through 3 subsequent Lovable commits
// (8c13094, 1e30520, 95d32fb). Something in the pipeline silently rejected all
// post-2d6d5f4 commits. Re-bumping this file as last-ditch trigger before
// falling back to manual Publish via user.
// Previous stamp: 2026-04-22T07:30Z — fix for ahk-cu/melanotan-i/peg-mgf/vip/
// cortagen/snap-8/pnc-27/cag/ksptn/pdrn/acetyl-hexapeptide-8 + /vendors/ion-peptide
// prerender stubs. The noscript crawl-list edit in cdfea09 is the actual fix;
// this file-touch just kicks the build.
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initAnalytics } from "./lib/analytics";
import { captureAttribution, initAttribution } from "./lib/attribution";
import { captureFirstTouch } from "./lib/firstTouch";

// Capture ad params (utm_*, rdt_cid, ...) off the landing URL BEFORE anything
// can navigate and rewrite the query string. Storage-only, no network, no DOM —
// safe to run ahead of render and cheap enough not to touch LCP.
captureAttribution();
// Then the first-touch record (source, medium, referrer, landing page), written
// once per browser and never overwritten. Same cost: storage only.
captureFirstTouch();

// Mount React FIRST so the LCP element paints before we kick off
// third-party pixel network requests. Then defer analytics to the
// browser's idle window — this drops the synchronous Meta + GA4 +
// Reddit pixel loaders out of the FCP critical path. Lighthouse
// 2026-04-29 had FCP at 3.9s+ savings flagged because these loaders
// were blocking the main thread before React even mounted.
createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Defer pixel/GA4 loaders to idle. Falls back to setTimeout for Safari,
// which doesn't yet ship requestIdleCallback. 1500ms is the upper bound:
// most idle slots fire well under that even on slow phones.
const deferAnalytics = () => {
  try {
    initAnalytics();
  } catch (err) {
    console.warn("[analytics] deferred init failed:", err);
  }
  try {
    // DOM-touching half of attribution (link decoration + click interceptor).
    // Deferred with the pixels: the click interceptor only has to exist before
    // a human can plausibly click a store link, which is well after idle.
    initAttribution();
  } catch (err) {
    console.warn("[attribution] deferred init failed:", err);
  }
};
if (typeof window !== "undefined") {
  const ric = (window as any).requestIdleCallback;
  if (typeof ric === "function") {
    ric(deferAnalytics, { timeout: 1500 });
  } else {
    setTimeout(deferAnalytics, 1200);
  }
}
